import Api from './Api'

export default {
    get(keyword, pageNumber, sort, pageSize) {
        return Api().get(`subjects?keyword=${keyword}&pageNumber=${pageNumber}&sort=${sort}&pageSize=${pageSize}`);
    },
    getNext() {
        return Api().get(`subjects/next`);
    },
    getAll() {
        return Api().post(`subjects/all`);
    },
    getOne(id) {
        return Api().get(`subjects/${id}`);
    },
    getFormularioFinal(idDisciplina = null) {
        return Api().get(`subjects/formulario-final${idDisciplina ? `?idDisciplina=${idDisciplina}` : ''}`);
    },
    update(idNotification){
        return Api().put('subject/update/visualizado', idNotification);
    }
}